import {
  translateCategory,
  translatePlace,
  translateWithWhom,
  translateFeeling,
  CategorySetType,
} from './categoryConfig';

// Legacy function - maintained for backward compatibility
// Now uses the categoryConfig system with default categories
export function enCategory(category: String, categorySet: CategorySetType = 'default') {
  return translateCategory(category as string, categorySet);
}

// Legacy function - maintained for backward compatibility
export function enPlaces(place: String, categorySet: CategorySetType = 'default') {
  return translatePlace(place as string, categorySet);
}

// Legacy function - maintained for backward compatibility
export function enTogetherness(togetherness: String, categorySet: CategorySetType = 'default') {
  return translateWithWhom(togetherness as string, categorySet);
}

// Legacy function - maintained for backward compatibility
export function enMood(mood: String, categorySet: CategorySetType = 'default') {
  return translateFeeling(mood as string, categorySet);
}


